import React, { useRef, useLayoutEffect, useEffect, useState } from 'react';

import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import tmicStyles from './tmic-styles';
import Center from '../stories/helpers/center';

export interface Props {
  data: {
    wordpressPage: {
      id: number;
      date: string;
      modified: string;
      path: string;
      slug: string;
      status: string;
      type: string;
      title: string;
      content: string;
      excerpt: string;
      wordpress_id: number;
      featured_media?: {
        source_url: string;
      };
    };
  };
}

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Frame: React.FC<{
  content?: string;
  container?: boolean;
  tmic?: boolean;
  uic?: boolean;
  otherHeadData?: string;
}> = ({
  content = '',
  container = false,
  tmic = false,
  uic = false,
  otherHeadData = '',
}) => {
    const frame = useRef<HTMLIFrameElement | null>(null);
    useLayoutEffect(() => {
      if (!frame.current || !frame.current.contentWindow) {
        return;
      }
      const doc = frame.current.contentWindow.document;
      doc.open();
      const toWrite = `
<head>
<base href="${window.location.origin}/" target="_PARENT">
<link rel="stylesheet" href="https://aaacdndev.blob.core.windows.net/wordpress/fonts/master.css">
${uic || tmic
          ? '<link rel="stylesheet" href="/wp-content/themes/aaawpmigrate/style.css">'
          : `
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.2.1/css/bootstrap.min.css" integrity="sha384-GJzZqFGwb1QTTN6wy59ffF1BuGJpLSa9DkKMp0DgiMDm4iYMj70gZWKYbI706tWS" crossorigin="anonymous">
    <link rel="stylesheet" href="https://aaacdndev.blob.core.windows.net/wordpress/css/base.css">
    <link rel="stylesheet" href="/wp-content/themes/aaawpmigrate/css/global.css">
    <link rel="stylesheet" href="/wp-content/themes/aaawpmigrate/css/aaa-footer.css">`
        }
<link rel="stylesheet" href="https://aaacdndev.blob.core.windows.net/wordpress/css/aaa-navigation.css">
<link rel="stylesheet" href="https://aaacdndev.blob.core.windows.net/wordpress/css/animate.css">
<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css">
${otherHeadData}
<link rel="stylesheet" href="/css/override.css">
<script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.6/umd/popper.min.js" integrity="sha384-wHAiFfRlMFy6i5SRaxvfOCifBUQy1xHdJ/yoi7FRNXMRBu5WHdZYu1hA6ZOblgut" crossorigin="anonymous"></script>
<script src="https://stackpath.bootstrapcdn.com/bootstrap/4.2.1/js/bootstrap.min.js" integrity="sha384-B0UglyR+jN6CkvvICOB2joaf5I4l3gm9GU6Hc1og6Ls7i6U/mkkaduKaBhlAXv9k" crossorigin="anonymous"></script>
<link rel="stylesheet" type="text/css" href="//s.swiftypecdn.com/assets/new_embed-20cee04df5c6e7e2687598f076a0147d.css"></link>
<style type="text/css">.st-install-Dqsy2GcxQVTbB_3TfPap .st-ui-result .st-ui-type-heading { color:#00338d !important }
.st-install-Dqsy2GcxQVTbB_3TfPap .st-ui-result em {font-style:normal; font-weight:bold; background-color:#f6fcfe !important}</style>
${tmic ? tmicStyles : ''}
</head>
<body>
<div class="site ${container ? 'container' : ''}">${content}</div>
<script>
  document.querySelectorAll('#typeform-full').forEach(function(el) {
    el.setAttribute('height', window.screen.availHeight + 'px');
  });
</script>
</body>
`
        .trim()
        .replace(
          /<\?php\s?\n?theme_img\(\);\s?\n?\?>/g,
          '/wp-content/themes/aaawpmigrate/img/'
        )
        .replace(
          /"\/wp-content\//g,
          `"https://${process.env.GATSBY_WORDPRESS_URL_PATH}/wp-content/`
        )
        .replace(
          /url\(\/wp-content\//g,
          `url(https://${process.env.GATSBY_WORDPRESS_URL_PATH}/wp-content/`
        )
        .replace(/<\/hr\s?>/g, '<hr>')
        .replace(/<\/link\s?>/g, '</link>');
      doc.write(toWrite);
      // console.log('toWrite', toWrite);
      doc.close();
    });

    const [loading, setLoading] = useState(true);

    const resizeHeight = () => {
      if (!frame.current || !frame.current.contentWindow) {
        return;
      }
      setLoading(false);
      frame.current.style.zIndex = '2';
      frame.current.style.height =
        frame.current.contentWindow.document.documentElement.scrollHeight +
        15 +
        'px';
    };

    useEffect(() => {
      const listener = () => {
        if (!frame.current || !frame.current.contentWindow) {
          return;
        }
        frame.current.style.height = '0px';
        frame.current.style.height =
          frame.current.contentWindow.document.documentElement.scrollHeight +
          15 +
          'px';

        console.log('resize eventListener');
      };

      if (typeof window !== 'undefined') {
        window.addEventListener('resize', listener);
      }

      return () => {
        if (typeof window !== 'undefined') {
          window.removeEventListener('resize', listener);
        }
      };
    }, []);

    return (
      <>
        {loading ? (
          <Center>
            <Spin indicator={antIcon} />
          </Center>
        ) : null}

        <iframe
          ref={frame}
          style={{
            border: 'none',
            width: '100%',
            height: 0,
            zIndex: -1,
            overflow: 'hidden',
          }}
          onLoad={resizeHeight}
        ></iframe>
      </>
    );
  };

export default Frame;
